import { z } from "zod";

import { UNLOCK_COMMENT_MAX_LENGTH } from "@/constants/access-request";
import { UNLOCK_MODAL_LABELS } from "@/constants/messages";
import { UnlockEntityTypeEnum } from "@/enum/access_request";

export const UnlockCommentSchema = z
  .string()
  .max(UNLOCK_COMMENT_MAX_LENGTH, UNLOCK_MODAL_LABELS.COMMENT_TOO_LONG);

export const UnlockRequestFormSchema = z.object({
  entityType: z.nativeEnum(UnlockEntityTypeEnum),
  storeCode: z.string(),
  search: z.string(),
  entityCode: z.string().min(1, UNLOCK_MODAL_LABELS.TARGET_REQUIRED),
  comment: UnlockCommentSchema,
});

export const UnlockApproveFormSchema = z.object({
  comment: UnlockCommentSchema,
});

export type UnlockApproveFormValues = z.infer<typeof UnlockApproveFormSchema>;

export type UnlockRequestFormValues = z.infer<typeof UnlockRequestFormSchema>;
